import {
    useState,
} from 'react';

import {
    IMAGE_URL,
} from '../../../path';

type Props = {
    whereToBuy?: any;
    onClose: () => void;
    onSave: (
        data: FormData
    ) => void;
};

export default function WhereToBuyModal({
                                            whereToBuy,
                                            onClose,
                                            onSave,
                                        }: Props)
{
    const [
        retailerName,
        setRetailerName
    ] = useState(
        whereToBuy?.retailer_name || ''
    );

    const [
        link,
        setLink
    ] = useState(
        whereToBuy?.link || ''
    );

    const [
        logo,
        setLogo
    ] = useState<File | null>(
        null
    );

    const [
        logoPreview,
        setLogoPreview
    ] = useState(
        whereToBuy?.logo || ''
    );

    const [
        isActive,
        setIsActive
    ] = useState(
        whereToBuy?.is_active ?? true
    );

    const getImageUrl = (
        path?: string
    ) => {

        if (!path) {
            return '';
        }

        if (
            path.startsWith(
                'http'
            ) ||
            path.startsWith(
                'blob:'
            )
        ) {

            return path;
        }

        return `${IMAGE_URL}${path}`;
    };

    const handleSubmit = (
        e: React.FormEvent
    ) => {

        e.preventDefault();

        const formData =
            new FormData();

        formData.append(
            'retailer_name',
            retailerName
        );

        formData.append(
            'link',
            link
        );

        formData.append(
            'is_active',
            isActive
                ? '1'
                : '0'
        );

        if (logo) {

            formData.append(
                'logo',
                logo
            );
        }

        onSave(
            formData
        );
    };

    return (

        <div
            className="modal-overlay"
            onClick={onClose}
        >

            <div
                className="modal-box"
                onClick={(e) =>
                    e.stopPropagation()
                }
            >

                <h2>

                    {whereToBuy
                        ? 'Edit Retailer'
                        : 'Add Retailer'}

                </h2>

                <form
                    className="modal-form"
                    onSubmit={
                        handleSubmit
                    }
                >

                    <label>
                        Retailer Name
                    </label>

                    <input
                        type="text"
                        value={
                            retailerName
                        }
                        onChange={(e) =>
                            setRetailerName(
                                e.target.value
                            )
                        }
                        required
                    />

                    <label>
                        Logo
                    </label>

                    {logoPreview && (

                        <img
                            src={
                                getImageUrl(
                                    logoPreview
                                )
                            }
                            alt=""
                            className="image-preview"
                        />

                    )}

                    <p className="field-hint">
                        Maximum file size: 2MB.
                        Supported formats:
                        JPG, PNG, WEBP,
                        SVG.
                    </p>

                    <input
                        type="file"
                        accept=".jpg,.jpeg,.png,.webp,.svg"
                        onChange={(e) => {

                            const file =
                                e.target.files?.[0];

                            if (!file) {
                                return;
                            }

                            if (
                                file.size >
                                2 * 1024 * 1024
                            ) {

                                alert(
                                    'Logo must be 2MB or smaller.'
                                );

                                return;
                            }

                            setLogo(
                                file
                            );

                            setLogoPreview(
                                URL.createObjectURL(
                                    file
                                )
                            );

                        }}
                    />

                    <label>
                        Link
                    </label>

                    <input
                        type="url"
                        value={link}
                        onChange={(e) =>
                            setLink(
                                e.target.value
                            )
                        }
                        placeholder="https://example.com"
                        required
                    />

                    <label>
                        Active
                    </label>

                    <select
                        value={
                            isActive
                                ? '1'
                                : '0'
                        }
                        onChange={(e) =>
                            setIsActive(
                                e.target.value ===
                                '1'
                            )
                        }
                    >

                        <option value="1">
                            Yes
                        </option>

                        <option value="0">
                            No
                        </option>

                    </select>

                    <div className="modal-actions">

                        <div className="left-actions">

                            <button
                                type="button"
                                className="cancel-btn"
                                onClick={
                                    onClose
                                }
                            >
                                Cancel
                            </button>

                        </div>

                        <div className="right-actions">

                            <button
                                type="submit"
                                className="action-btn"
                            >
                                Save
                            </button>

                        </div>

                    </div>

                </form>

            </div>

        </div>

    );
}
